import { useReducer, useEffect, useRef } from "react";
import energyConsumptionReducer from "./reducer";
import { fetchEnergyConsumption } from "./api";
import ACTIONS from "./actions";
import { getEnergyConsumptionDateFormat, transformEnergyConsumptionData } from "../../../../lib/utils/utility";

const initialState = {
  isLoading: false,
  isError: false,
  data: [],
};

const FETCH_DEBOUNCE_MS = 1000;

async function getEnergyConsumptionDetails(dispatch, chargerId, timeRange, siteId, siteTimezone) {
  const startTime = getEnergyConsumptionDateFormat(new Date(timeRange[0]), siteTimezone);
  const endTime = getEnergyConsumptionDateFormat(new Date(timeRange[1]), siteTimezone);
  dispatch({ type: ACTIONS.FETCH_ENERGY_CONSUMPTION_INIT });
  let energyConsumptionData;
  try {
    energyConsumptionData = await fetchEnergyConsumption(siteId, startTime, endTime, chargerId);
  } catch {
    dispatch({ type: ACTIONS.FETCH_ENERGY_CONSUMPTION_FAILURE });
    return;
  }
  if (energyConsumptionData) {
    const data = energyConsumptionData?.e_c;
    const finalResult = transformEnergyConsumptionData(
      data,
      startTime,
      endTime,
      timeRange[0],
      timeRange[1],
      siteTimezone
    );
    dispatch({ type: ACTIONS.FETCH_ENERGY_CONSUMPTION_SUCCESS, payload: finalResult });
  } else {
    dispatch({ type: ACTIONS.FETCH_ENERGY_CONSUMPTION_FAILURE });
  }
}

export function useEnergyConsumptionReducer({ chargerId, timeRange, siteId, siteTimezone }) {
  const [state, dispatch] = useReducer(energyConsumptionReducer, initialState);
  const lastFetchRef = useRef(null);

  useEffect(() => {
    if (!chargerId || !timeRange || !siteId) return;

    const fetchKey = `${siteId}_${chargerId}_${new Date(timeRange[0]).getTime()}_${new Date(timeRange[1]).getTime()}`;

    const handler = setTimeout(() => {
      if (lastFetchRef.current === fetchKey) return;
      lastFetchRef.current = fetchKey;
      getEnergyConsumptionDetails(dispatch, chargerId, timeRange, siteId, siteTimezone);
    }, FETCH_DEBOUNCE_MS);

    return () => clearTimeout(handler);
  }, [chargerId, timeRange, siteId, siteTimezone]);

  return {
    state,
    dispatch,
  };
}

export default useEnergyConsumptionReducer;
